import axios from "axios"
import { customToast } from "../components/toast/custom-react-toastify/v1"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function ReturnExchangesApi(props) {
    return {
        searchList: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/return-exchanges`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        createListFromSystem: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/return-exchanges/from-system`, body, {
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        copyCreateList: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/return-exchanges/copy-create`, body, {
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        customToast.success('복사되었습니다.');
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        updateList: async ({ params, headers, body }) => {
            return await axios.put(`${MAIN_API_HOST}/return-exchanges`, body, {
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        customToast.success('수정되었습니다.');
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        deleteList: async ({ params, headers, body }) => {
            return await axios.delete(`${MAIN_API_HOST}/return-exchanges`, {
                data: body,
                headers: headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
    }
}